module.exports = __webpack_public_path__ + "static/media/silestone.3dcccffd.svg";